/**
 * Orchestrator Agent Parameter Schema
 */

import { z } from "zod";

/**
 * Parameters for the orchestrator
 */
export const OrchestratorParamsSchema = z.object({
    message: z.string()
        .describe("The user message or task to orchestrate. This is the primary input that the orchestrator will process and coordinate tools to fulfill."),
}).catchall(z.unknown()); // Allow additional properties for flexibility

/**
 * Response from the orchestrator
 */
export type OrchestratorResponse = { 
    response: { 
        content: string;
        message: string;
        /** Tool calls made during execution */
        toolCalls?: Array<{ name: string; result: unknown }>;
    } 
};

// ═══════════════════════════════════════════════════════════════════════════
// TYPE EXPORTS
// ═══════════════════════════════════════════════════════════════════════════

export type OrchestratorParams = z.infer<typeof OrchestratorParamsSchema>;

